import { createSelector } from 'reselect';
import { showSessionAIMsgSelector } from 'selectors/testTarget/offers/showSessionAIMsg/showSessionAIMsgSelector';

const showSelector = createSelector(showSessionAIMsgSelector, showSessionAIMsg => !!showSessionAIMsg.show);

export { showSelector };
